import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-172d642c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "background-color": "#f5f5f5",
    "height": "100%",
    "min-height": "9rem",
    "padding-bottom": "1.5rem"
  }
};
var _hoisted_2 = {
  class: "main"
};

var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-172d642c><h3 style=\"text-align:center;\" data-v-172d642c>公司简介</h3><p data-v-172d642c>杭州我爱号码网电子商务有限公司（简称“我爱号码网”）成立于2010年，注册资本1000万元，是一家专业通信产品互联网销售公司。</p><p data-v-172d642c>杭州我爱号码网电子商务有限公司围绕运营商号卡业务为中心，解决客户刚需为主线，致力打造全国最为完善的通信号码及套餐定制平台。</p><p data-v-172d642c>为了丰富号源及全国性的个性套餐，开放B端的互换资源的平台。平台以全国300多家天猫通信店、京东通信店、拼多多通信店、个体专属的门户网站等做通信业务的商家为目标群体，共享号源和个性定制套餐。 为了配合平台发展，我司目前拥有多个自营的天猫通信店、京东、拼多多店铺。已经合作B端商家有1000余家，欢迎喜欢号码的小伙伴们加入合作。</p><p data-v-172d642c> 拼多多店铺：<a href=\"http://mobile.yangkeduo.com/mall_page.html?mall_id=571878373\" style=\"color:#ff4c4c;\" target=\"_blank\" data-v-172d642c>我爱号码网通信专营店</a></p></div><div data-v-172d642c><h3 data-v-172d642c>联系我们</h3><p data-v-172d642c>公司地址：浙江省杭州市拱墅区石桥路293号7楼706室</p><p data-v-172d642c>联系电话：0571-28888520</p></div>", 2);

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "微信公众号", -1);
});

var _hoisted_6 = {
  style: {
    "font-size": "0.22rem",
    "text-align": "center",
    "margin-top": "0.5rem"
  }
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "公司名称：杭州我爱号码网电子商务有限公司", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "公司地址：浙江省杭州市拱墅区石桥路293号706室", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系电话：0571-28888520", -1);
});

var _hoisted_10 = {
  href: "http://www.beian.gov.cn",
  style: {
    "display": "inline-block",
    "text-decoration": "none",
    "height": "20px",
    "line-height": "20px"
  },
  target: "_blank"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "浙公网安备 33010502006968号", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    style: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    target: "_blank"
  }, "浙ICP备19034816号-1")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_image = _resolveComponent("van-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", null, [_hoisted_5, _createElementVNode("p", null, [_createVNode(_component_van_image, {
    src: require('@/assets/gzh.jpg')
  }, null, 8, ["src"])])])]), _createElementVNode("footer", _hoisted_6, [_hoisted_7, _hoisted_8, _hoisted_9, _createElementVNode("div", null, [_createElementVNode("a", _hoisted_10, [_createVNode(_component_van_image, {
    src: require('@/assets/gaba.png')
  }, null, 8, ["src"]), _hoisted_11])]), _hoisted_12])]);
}